import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { FeaturesManager, GetPackageByIdPayload, Packages } from '../../../../utils/request';
import { GetCompanyFeaturesPayload } from '../../../../packages/packagesGrid/types';
import { Feature } from '@nirvana/shared/constants';
import { GetCompanyPackagesResponse, GetPackageByIdResponse } from '../../../../utils/response';
import { LanguageData } from '../../../../packages/types/language-data';
import { sanitizeArray } from '../../../../utils/sanitization.utils';

export class InstallAgentPanelDataProvider extends BaseWebComponentDataProvider {
  public async getCompanyPackages(companyId: string): Promise<GetCompanyPackagesResponse> {
    return await Packages.getCompanyPackages(companyId);
  }

  public async getPackageById(payload: GetPackageByIdPayload): Promise<GetPackageByIdResponse> {
    return await Packages.getPackageById(payload);
  }

  public getLanguages(): LanguageData[] {
    const data = this.dependencies.getLanguages();
    return sanitizeArray(data);
  }

  public async getFeaturesByCompany(payload: GetCompanyFeaturesPayload): Promise<Feature[]> {
    return FeaturesManager.getFeaturesByCompany(payload);
  }
}
